import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { GenVideoPreviewData } from '../../../../../../../models/google-template/preview-interfaces/gen-video-preview-data.interface';
import { VideoFormat } from '../../../../../../../utils/youtube-format-helper';
import { YoutubeShortsAdMobileShellComponent } from './youtube-shorts-ad-mobile-shell.component';

/**
 * Shorts ad for the 9:16 creative: the native Shorts format, so it fills the
 * whole screen with no bands.
 */
@Component({
    selector: 'app-gen-youtube-shorts-ad-mobile-fullscreen',
    imports: [YoutubeShortsAdMobileShellComponent],
    template: '<app-gen-youtube-shorts-ad-mobile-shell [data]="data" [format]="format" />',
    changeDetection: ChangeDetectionStrategy.Eager
})
export class YoutubeShortsAdMobileFullscreenPreviewComponent {
  @Input() data!: GenVideoPreviewData;

  readonly format: VideoFormat = '9:16';
}
